var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCryptoKey = function SvgCryptoKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.55 6.937a5.378 5.378 0 0 1 7.837 2.619h9.657L23 11.51l-1.955 1.956h-1.467l-1.467 1.466-1.467-1.466h-.977L14.2 14.933l-1.467-1.466h-1.346a5.378 5.378 0 1 1-7.838-6.53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.404 12.98a1.467 1.467 0 1 0 0-2.934 1.467 1.467 0 0 0 0 2.934"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.088 1.75a.75.75 0 1 0 1.5 0 .75.75 0 1 0-1.5 0M5.404 22.283a.75.75 0 1 0 1.5 0 .75.75 0 1 0-1.5 0M21.533 3.705a.75.75 0 1 0 1.5 0 .75.75 0 1 0-1.5 0M21.533 19.35a.75.75 0 1 0 1.5 0 .75.75 0 1 0-1.5 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.378 7.6V4.665c0-.54.438-.978.978-.978h.977M12 1.733h.977c.54 0 .978.438.978.978V7.6M16.4 15.911v2.445c0 .54.438.977.978.977h1.955M9.556 22.267h1.956c.54 0 .977-.438.977-.978V16.4"
  })));
};
export default SvgCryptoKey;